/* eslint-disable */
const hostname = window && window.location && window.location.origin;
const basePath = "/firm_api";
const domain = `${hostname}${basePath}/v1/category`

// const domain = `http://localhost:5101/api/v1/category`;

/* eslint-disable end */

export default {
  getAllCategories: `${domain}/getcategoriesforutility`,
  saveAllCategories: `${domain}/updatecategory`,
  addCategory: `${domain}/addcategory`,
  getTaskCount: `${domain}/getcategorycountbyid`,
  getActiveCategories: `${domain}/getactivecategories`
};
